/**
 * The asterisk shown after the label of a field the selected stage requires.
 * @returns The required marker
 */
export function RequiredMark() {
  return <span className="ml-0.5 text-destructive">*</span>;
}
